'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable sort-keys, max-len */
exports.default = {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: 'Se connecter',
                signup: 'Signup To Bid',
                register_short: 'Inscription',
                register_long: 'Inscription aux enchères',
                pending: 'Inscription en attente',
                declined: 'Inscription refusée',
                closed: 'Lot fermé',
                sent: 'Votre offre a été envoyée',
                outbid: 'Il y a eu une contre-offre, Offre {amount}',
                bid: 'Offre de {amount}',
                winning: 'Vous avez gagné'
            },
            conversions: {
                lot_number: 'Lot # {lotNumber}'
            },
            description: {
                estimate_range: 'Estimation de {low} à {high}',
                images_label: '{currentImageNumber} / {totalImages}'
            },
            messages: {
                competing_bid_amount: '{amount}: Encanteur adverse',
                competing_bidder_outbid_by_liveauctioneers_absentee: 'Encanteur adverse a été dépassé par encanteur {paddleNumber}',
                last_bid_retracted: 'Dernière enchère de {amount} retirée',
                liveauctioneers_bid_amount: '{amount}: Encanteurs sur place - Encanteur {paddleNumber}',
                liveauctioneers_bid_amount_absentee: '{amount}: Encanteurs sur place - Encanteur {paddleNumber} - Pré-enchère',
                lot_number_passed: 'Lot # {lotNumber} Passé',
                lot_number_reopened: 'Lot # {lotNumber} Réactivé',
                lot_number_skipped: 'Lot # {lotNumber} Ignoré',
                lot_number_unsold: 'Lot # {lotNumber} Non vendu',
                lot_opened_asking: 'Lot # {lotNumber} ouvert - Demande {amount}',
                lot_sold_competing_bidder: 'Lot # {lotNumber} vendu à {amount} à l\'encanteur adverse',
                lot_sold_liveauctioneers_bidder: 'Lot # {lotNumber} vendu à {amount} à l\'encanteur {paddleNumber}',
                my_bid_amount: '{amount}: Mon offre',
                my_bid_amount_absentee: '{amount}: Ma Pré-Enchère',
                my_bid_retracted: 'Votre enchère de {amount} a été retirée',
                registration_approved: 'Votre inscription a été approuvée',
                reserve_not_met: 'Réserve non atteinte',
                you_been_outbid_by_liveauctioneers_absentee: 'Vous avez été surenchéri par l\'offre d\'absence de l\'enchérisseur {paddleNumber}',
                you_ve_won_lot: 'Vous avez gagné le lot # {lotNumber}'
            },
            missives: {
                fair_warning_lot_about_to_close: 'Avertissement...Cette enchère est sur le point d\'être fermée',
                going_once_going_twice: 'Une fois...Deux fois...',
                third_and_final_warning: 'Troisième et dernier appel'
            },
            status: {
                remaining: '{remaining} des {total} lots restants'
            },
            thumbnail_scroller: {
                next: 'Prochains lots'
            }
        }
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/intl/fr.js
// module id = SYJM
// module chunks = 60